module.exports = __webpack_public_path__ + "static/media/male_placeholder.3c02425a.jpg";